import { render, staticRenderFns } from "./group-column.vue?vue&type=template&id=36c3ad80&"
import script from "./group-column.vue?vue&type=script&lang=js&"
export * from "./group-column.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports